import { makeSx } from '../../../theme/_utils'
import { defaultPalette } from '../../../theme/idsTheme'

export default makeSx({
    button: {
        width: '100%',
        padding: '1rem',
        backgroundColor: defaultPalette.secondary.dark,
        color: defaultPalette.white.main,
        '&:hover': {
            backgroundColor: defaultPalette.secondary.dark,
            opacity: 0.9,
        },
    },
    buttonSecondary: {
        backgroundColor: defaultPalette.primary.main,
        color: defaultPalette.white.main,
        '&:hover': {
            backgroundColor: defaultPalette.primary.main,
            opacity: 0.9,
        },
    },
    buttonInnerLink: {
        color: 'inherit',
        textDecoration: 'none',
        fontWeight: 600,
    },
})
